import React, { forwardRef } from 'react';
import Button from '../../atoms/Button';
import Icon from '../../atoms/Icon';
const IconButton = forwardRef(function IconButton({ icon, testId = 'store-icon-button', ...buttonProps }, ref) {
    return (React.createElement(Button, Object.assign({ ref: ref, "data-store-icon-button": true, testId: testId }, buttonProps),
        React.createElement(Icon, { component: icon })));
});
export default IconButton;
//# sourceMappingURL=IconButton.js.map